import { CircleCircle } from '@calm/evexia-web-sdk';
import {
    ActiveCircleIdContext,
    DEFAULT_ACTIVE_CIRCLE_ID,
} from '@rhg/providers/active-circle-id';
import { useCallback, useContext } from 'react';
import { useCircle } from '../use-circle';
import { ActiveCircleIdState } from './types';

export function useActiveCircleId() {
    const currentContext = useContext(ActiveCircleIdContext);
    return currentContext || ({} as ActiveCircleIdState);
}

export function useActiveCircle() {
    const { activeCircleId, hasActiveCircle, setActiveCircleId } =
        useActiveCircleId();
    const { circle, hasPermission, ...otherProps } = useCircle(activeCircleId);

    const setActiveCircle = useCallback(
        (circle?: CircleCircle | number) => {
            if (typeof circle === 'number') {
                setActiveCircleId(circle);
                return;
            }
            setActiveCircleId(
                circle?.recipient?.id ?? DEFAULT_ACTIVE_CIRCLE_ID
            );
        },
        [setActiveCircleId]
    );

    return {
        activeCircleId,
        hasActiveCircle,
        activeCircle: circle,
        setActiveCircle,
        hasPermission,
        ...otherProps,
    };
}
